import React, { JSX } from 'react';
import { Box, BoxProps, Breakpoint } from '@mui/material';

// TODO move to kit
type ResponsiveBoxProps = BoxProps & {
  hiddenUp?: Breakpoint;
  hiddenDown?: Breakpoint;
};

export const ResponsiveBox = ({
  hiddenDown,
  hiddenUp,
  ...boxProps
}: ResponsiveBoxProps): JSX.Element => {
  if (!hiddenDown && !hiddenUp) {
    throw new Error('At least one must be defined: hiddenDown, hiddenUp');
  }

  return (
    <Box
      display={{
        xs: hiddenDown ? 'none' : 'block',
        [(hiddenDown || hiddenUp)!]: hiddenDown ? 'block' : 'none'
      }}
      {...boxProps}
    />
  );
};
